
const routes = [
    {
        meta: {
            title: 'ログイン',
            fullScreen: true
        },
        path: '/login',
        name: 'login',
        component: () => import('@/spViews/Login')
    },
    {
        meta: {
            title: 'ホーム'
        },
        path: '/home',
        name: 'home',
        component: () => import('@/spViews/Home'),
        children: [
            {
                meta: {
                    title: 'トレーニング動画',
                    back: '/home'
                },
                path: 'training-video',
                name: 'training-video',
                props: true,
                component: () => import('@/spViews/TrainingVideoPlayer.vue')
            }
        ]
    },
    {
        meta: {
            title: 'トレーニングメモ',
            back: '/home'
        },
        path: '/training-memo',
        name: 'training-memo',
        component: () => import('@/spViews/HomeCalendar')
    },
    {
        meta: {
            title: '目標設定'
        },
        path: '/goal-settings',
        name: 'goal-settings',
        component: () => import('@/views/GoalSettings')
    },
    {
        meta: {
            title: 'Myデータ'
        },
        path: '/mydata',
        name: 'mydata',
        component: () => import('@/spViews/MyData')
    },
    // {
    //     meta: {
    //         title: 'イベント一覧',
    //     },
    //     path: '/event-list',
    //     name: 'event-list',
    //     component: () => import('@/spViews/EventList')
    // },
    // {
    //     meta: {
    //         title: 'イベント詳細',
    //         back: '/event-list'
    //     },
    //     path: '/event-list/detail/:event_id/',
    //     name: 'eventdetail',
    //     component: () => import('@/spViews/EventDetail')
    // },
    {
        meta: {
            title: 'ランキング',
        },
        path: '/ranking',
        name: 'ranking',
        redirect: { name: 'local_individual_ranking' },
        component: () => import('@/views/Ranking'),
        children: [
            {
                meta: {
                    title: '個人ランキング（チーム内）',
                },
                path: 'individual/local',
                name: 'local_individual_ranking',
                component: () => import('@/views/Ranking')
            },
            {
                meta: {
                    title: '個人ランキング（全国）',
                },
                path: 'individual/national',
                name: 'national_individual_ranking',
                component: () => import('@/views/Ranking')
            },
            {
                meta: {
                    title: 'チームランキング（全国）',
                },
                path: 'team/national',
                name: 'national_team_ranking',
                component: () => import('@/views/Ranking')
            },
        ],
    },
    {
        meta: {
            title: 'ノート'
        },
        path: '/note',
        name: 'note',
        component: () => import('@/views/Note')
    },
    {
        meta: {
            title: 'ノート記入'
        },
        path: '/note/write_note/:date',
        name: 'write_note',
        component: () => import('@/views/WriteNote')
    },
    {
        meta: {
            title: 'ノート記入確認',
        },
        path: '/note/write_confirm_note',
        name: 'write_confirm_note',
        component: () => import('@/views/WriteConfirmNote')
    },
    {
        meta: {
            title: 'ノート閲覧'
        },
        path: '/note/view_note/:noteId',
        name: 'view_note',
        component: () => import('@/views/ViewNote')
    },
    {
        meta: {
            title: 'ノート編集'
        },
        path: '/note/edit_note/:noteId',
        name: 'edit_note',
        component: () => import('@/views/EditNote')
    },
    {
        meta: {
            title: '機能設定'
        },
        path: '/setting',
        name: 'setting',
        component: () => import('@/views/SettingView')
    },
    {
        meta: {
            title: '測定結果一覧'
        },
        path: '/evaluation',
        name: 'evaluation',
        component: () => import('@/views/EvaluationResult')
    },
    // {
    //     meta: {
    //         title: 'プロフィール'
    //     },
    //     path: '/profile',
    //     name: 'profile',
    //     component: Profile
    // },
    {
        meta: {
            title: '利用ガイド'
        },
        path: '/guide',
        name: 'guide',
        component: () => import('@/views/Guide')
    },
    {
        meta: {
            title: 'お知らせ一覧'
        },
        path: '/information',
        name: 'information',
        component: () => import('@/spViews/Information')
    },
    {
        meta: {
            title: 'お知らせ詳細',
            back: '/information'
        },
        path: '/information/detail/:infoId',
        name: 'informationdetail',
        component: () => import('@/spViews/InformationDetail'),
        props: true
    },
    {
        meta: {
            title: 'プロフィール'
        },
        path: '/trainingprofile',
        name: 'profile',
        component: () => import('@/spViews/Profile'),
    },
    {
        meta: {
            title: '活動履歴'
        },
        path: '/activity',
        name: 'activity',
        component: () => import('@/spViews/ActivityList'),
    },
        {
        meta: {
            title: 'ユーザーマニュアル・よくある質問',
        },
        path: '/faq',
        name: 'faq',
        component: () => import('@/views/FAQ'),
    },
    // 存在しないpathは、ホーム画面にリダイレクト
    {
        path: '/:pathMatch(.*)*',
        redirect: { name: 'home' }
    },

    {
        meta: {
            title: '基本情報入力',
            fullScreen: true
        },
        path: '/userinfoform',
        name: 'userinfoform',
        component: () => import('@/spViews/UserInfoForm')
    },
    {
        meta: {
            title: '決済情報入力',
            fullScreen: true
        },
        path: '/payment',
        name: 'payment',
        component: () => import('@/views/PaymentView'),
        beforeEnter: (to, from, next) => {
            window.location.href = '/top/#/plans'
        }
    },
]

export default routes
